<template>
  <div class="video-ptz_wrap">
    <div class="control_panel">
      <div id="dhplayer-pan-tilt"></div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  created() {
  },
  mounted() {
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.video-ptz_wrap {
  padding: 0 16px;
  width: 100%;
  height: 100%;
  // @include set_theme_color(background-color, left-menu-bg-color);
  @include set_theme_color(background-color, main-content-bg-color);
  display: flex;
  justify-content: space-around;

  .control_panel {
    display: flex;
    justify-content: space-around;
  }
}
</style>
